/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivUtmDtoGen } from "@/services/mrfiktiv/v1/data-contracts";

export type IUtmParameter = MrfiktivUtmDtoGen;

@IsFilterable
export class UtmParameter implements MrfiktivUtmDtoGen {
  /**
   * Used to identify which ads campaign this referral references. Use utm_id to identify a specific ads campaign.
   */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.utm.id"
  })
  utm_id?: string | null;

  /**
   * 	Identifies which site sent the traffic, and is a required parameter.
   * 	Use utm_source to identify a search engine, newsletter name, or other source.
   */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.utm.source"
  })
  utm_source?: string | null;

  /**
   * Identifies what type of link was used, such as email or pay-per-click advertising.
   * Use utm_medium to identify a medium such as email or cost-per-click.
   */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.utm.medium"
  })
  utm_medium?: string | null;

  /**
   * Identifies a specific product promotion or strategic campaign.
   * Used for keyword analysis. Use utm_campaign to identify a specific product promotion or strategic campaign.
   */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.utm.campaign"
  })
  utm_campaign?: string | null;

  /**
   * Identifies search terms.
   * Used for paid search. Use utm_term to note the keywords for this ad.
   */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.utm.term"
  })
  utm_term?: string | null;

  /**
   * Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link. It is often used for A/B testing and content-targeted ads.
   * Used for A/B testing and content-targeted ads. Use utm_content to differentiate ads or links that point to the same URL.
   */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.utm.content"
  })
  utm_content?: string | null;

  constructor(obj?: MrfiktivUtmDtoGen | null) {
    this.utm_id = obj?.utm_id;
    this.utm_source = obj?.utm_source;
    this.utm_medium = obj?.utm_medium;
    this.utm_campaign = obj?.utm_campaign;
    this.utm_term = obj?.utm_term;
    this.utm_content = obj?.utm_content;
  }
}
